module.exports = __webpack_public_path__ + "static/img/logo18.60373dd4.png";